import * as React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={104}
    height={86}
    viewBox={'0 0 104 86'}
    {...props}
    fill="none"
    stroke="none">
    <Circle cx={83} cy={11} r={11} fill={props.fill || '#B15500'} />
    <Circle cx={63.205} cy={43.119} r={4.16} fill={props.fill || '#B15500'} />
    <Circle cx={11.992} cy={6.773} r={2.773} fill={props.fill || '#B15500'} />
    <Path
      fill={props.fill || '#B15500'}
      d="M78.87 73.138c31.061 27.819 33.689 75.55 5.87 106.611-27.819 31.06-75.55 33.688-106.61 5.869-31.061-27.819-33.689-75.55-5.87-106.61C-14.398 64.11 3.526 55.752 21.993 54.158c4.298-.37 7.842-3.812 7.833-8.126l-.003-1.691c-.004-2.068-1.327-3.853-2.887-5.211-4.48-3.9-4.952-10.694-1.052-15.174 3.9-4.48 10.693-4.952 15.174-1.052 4.48 3.9 4.952 10.693 1.052 15.174-.332.381-.685.734-1.056 1.057-2.649 2.308-5.48 5.128-5.473 8.642.006 3.646 2.793 6.653 6.38 7.3 13.294 2.395 26.11 8.387 36.91 18.06Z"
    />
  </Svg>
);
export default SvgComponent;
